import { render } from "./CodeEditorComponent.vue?vue&type=template&id=565ea5f4"
import script from "./CodeEditorComponent.vue?vue&type=script&lang=js"
export * from "./CodeEditorComponent.vue?vue&type=script&lang=js"

import "./CodeEditorComponent.vue?vue&type=style&index=0&id=565ea5f4&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__